import { ScrBaseResponse, ScrMessage } from "../services/base.service";
import { StringOrPhoneNumber } from "./common.model";
import { Field, ObjectType } from "./decorators";


@ObjectType()
export class User {
    @Field({ q: ['summary', 'all'] }) public userId!: number;
    @Field({ q: ['summary', 'all'] }) public userName!: string | null;
    @Field() public accountId!: number;
    @Field({ q: ['summary', 'all'] }) public firstName!: string;
    @Field({ q: ['summary', 'all'] })public lastName!: string;
    @Field() public company!: string;
    @Field() public address1!: string;
    @Field() public address2: string | undefined;
    @Field() public city!: string;
    @Field() public state!: string;
    @Field() public country!: string;
    @Field() public zip?: string;
    @Field({ q: ['summary', 'all'] }) public phone!: StringOrPhoneNumber;
    @Field({ q: ['summary', 'all'] }) public phoneExtension: string | undefined;
    @Field({ q: ['summary', 'all'] }) public email!: string;
    @Field({ q: ['summary', 'all'] }) public roleList!: string[];
    @Field() public updatedBy!: string;
    @Field() public emailCategoryList!: string[];
    @Field() public optionList!: string[];
    @Field() public updateTime!: string;
    @Field() public createTime!: string;
    @Field({ q: ['summary', 'all'] }) public disabled!: boolean;
    @Field({ q: ['summary', 'all'] }) public emailVerified!: boolean;
    @Field({ q: ['summary', 'all'] }) public lastLoginTime?: string;

    // client only.
    public name?: string;
    public confirmEmail?: string;
    public emailChanged!: boolean;

}

export interface EditUserRequest {
    userName: string;
    disabled: boolean;
}

export class GetUsersResponse extends ScrBaseResponse {
    constructor(public users: User[], status: string, messages: ScrMessage[]) {
        super(status, messages);
    }
}

export class GetUserProfileResponse extends ScrBaseResponse {
    constructor(public user: User, status: string, messages: ScrMessage[]) {
        super(status, messages);
    }
}

export class UpdateUserProfileRequest {
    constructor(public status: string, public messages: { code: string, message: string }[], public updateUserResponse: { emailChanged: boolean }, public emailExists: boolean) { }
}